import { useLocation } from 'react-router-dom';

import AutoPauseWarningModal from '@/pages/workgroup/autoPause/AutoPauseWarningModal';
import { isWorkspaceScopedPath } from '@/pages/workgroup/autoPause/pauseHold';
import { useAutoPauseGuard } from '@/pages/workgroup/autoPause/useAutoPauseGuard';
import { ConfirmResumeWorkspace } from '@/pages/workgroup/tab/SettingMenu';

/**
 * Mounted once in the home layout. Warns before an idle workspace auto-pauses, keeps it alive while
 * the user is actually working, and offers to resume one that has already paused.
 */
export default function AutoPauseGuard() {
  const { pathname } = useLocation();
  const enabled = isWorkspaceScopedPath(pathname);

  const {
    warningWorkspace,
    msRemaining,
    pausedWorkspace,
    isExtending,
    onKeepAlive,
    onDismissWarning,
    onDismissResume,
    onResumed,
  } = useAutoPauseGuard(enabled);

  if (pausedWorkspace) {
    return (
      <ConfirmResumeWorkspace
        isOpen={true}
        onClose={onDismissResume}
        onResumed={onResumed}
        workspace={pausedWorkspace}
      />
    );
  }

  if (!warningWorkspace) {
    return null;
  }

  return (
    <AutoPauseWarningModal
      workspace={warningWorkspace}
      msRemaining={msRemaining}
      isExtending={isExtending}
      onKeepAlive={onKeepAlive}
      onDismiss={onDismissWarning}
    />
  );
}
